<template>
  <el-dialog
    ref="chatDialog"
    :visible.sync="config.show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :fullscreen="!isDesktop"
    :show-close="false"
    :top="marginTop"
    custom-class="pop_page noscroll reply chatDialog"
  >
    <div slot="title" class="header">
      <div class="left">
        &nbsp;
      </div>
      <div class="middle margin-left8">
        {{ (state.workCount.post_count? state.workCount.post_count : '') + $t('i.comment') + (work.name || '') }}
      </div>
      <div class="float-right">
        <el-button class="tap-btn iconfont my-close size20" @click="closePop(config)" />
      </div>
    </div>
    <div>
      <comment-list
        v-show="config.show"
        mod="comment"
        :view="view"
        :state="state"
        :file="work"
        :login-status="loginStatus"
        :login-user-id="loginUserId"
        :is-pop="true"
        @receive="handle"
      />
    </div>
  </el-dialog>
</template>
<script>
import commentList from '@/components/web/commentList'
import { mixins } from '@/mixins/common'
export default {
  components: {
    commentList
  },
  mixins: [mixins],
  data() {
    return { total: 0 }
  },
  computed: {
    config() {
      return this.view.comment
    },
    work() {
      return this.config.work
    }
  },
  methods: {
    handle(act, data) {
      if (act === 'setTotal') {
        this.setTotal(...data)
      } else {
        this.emit(act, data)
      }
    },
    setTotal(total) {
      this.total = total || 0
    }
  }
}
</script>
